<template>
  <div class="expansion-panel-item">
    <div class="expansion-panel-item-inner">
      <div class="label-wrapper">
        <p>{{ formatDate }} {{ scheduledHour }}</p>
      </div>
      <div class="label-wrapper">
        <p>{{ messageType }}</p>
      </div>
      <div class="label-wrapper">
        <p>{{ messageName }}</p>
      </div>
      <div
        class="frequency-indicator"
        :style="{ 'background-color': computedColor }"
      ></div>
    </div>
    <div class="btnWrapper">
      <button-global
        type="negative"
        text="DELETE"
        size="small"
        @eventPassed="showApproveModal = true"
      ></button-global>
      <button-global
        type="positive"
        text="EDIT"
        size="small"
        @eventPassed="editMessage"
      ></button-global>
    </div>
    <transition name="fadeInModal">
      <approve-modal
        @yes="deleteMessage"
        @no="showApproveModal = false"
        v-if="showApproveModal"
      >
        <p slot="text">Are you sure you want to delete this message?</p>
      </approve-modal>
    </transition>
  </div>
</template>

<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import ApproveModal from "@/components/GlobalComponents/ApproveModal";
import { firestore } from "@/firebase";

export default {
  components: {
    ButtonGlobal,
    ApproveModal,
  },
  props: {
    sendingAt: Number,
    scheduledHour: String,
    messageType: String,
    selectionType: String,
    messageName: String,
    messageFrequency: String,
    roomList: {
      type: [Array, Boolean],
      defualt: null,
    },
    messageContent: String,
    subjectContent: {
      type: [String, Boolean],
    },
    messageID: String,
  },
  data() {
    return {
      showApproveModal: false,
    };
  },
  computed: {
    computedColor() {
      switch (this.messageFrequency.toUpperCase()) {
        case "DAILY":
          return "#005826";
        case "WEEKLY":
          return "#23a94a";
        default:
          return "#cce2d0";
      }
    },
    formatDate() {
      return new Date(this.sendingAt).toISOString().slice(0, 10);
    },
  },
  methods: {
    editMessage() {
      this.$emit("editSelectedMessage");
    },
    deleteMessage() {
      firestore
        .collection("MultimessageScheduler")
        .doc(`${this.$hotelId}`)
        .collection("ScheduledMessages")
        .doc(`${this.messageID}`)
        .delete()
        .then(() => {
          this.showApproveModal = false;
          location.reload();
          this.$toastEvents.push({
            type: "copy",
            title: "Deletion",
            content: "Message has been deleted",
            id: +new Date(),
          });
        })
        .catch((e) => {
          console.log(e);
          this.showApproveModal = false;
          this.$toastEvents.push({
            type: "negative",
            title: "Error",
            content: "Something went wrong",
            id: +new Date(),
          });
        });
    },
  },
};
</script>

<style scoped>
.expansion-panel-item {
  background-color: white;
  padding: 10px 10px;
  margin: 15px 0;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  transition: all 0.3s;
  cursor: pointer;
}
.expansion-panel-item:hover {
  background-color: #f7f7f7;
}
.expansion-panel-item-inner {
  flex-grow: 1;
  display: flex;
  align-items: center;
}
.label-wrapper {
  flex-basis: 28%;
}
.label-wrapper > p {
  text-align: left;
}
.btnWrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.frequency-indicator {
  width: 40px;
  height: 10px;
  margin-left: 8px;
  border-radius: 5px;
}
.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: all 0.3s;
  max-height: 120px;
}
.fadeIn-enter,
.fadeIn-leave-to {
  opacity: 0;
  max-height: 0px;
}
@media screen and (max-width: 1025px) {
  .label-wrapper {
    flex-basis: 28%;
  }
}
@media screen and (max-width: 769px) {
  .btnWrapper {
    flex-direction: column;
  }
  .btnWrapper > div {
    margin-bottom: 10px;
  }
  .expansion-panel-item-inner {
    align-items: center;
    justify-content: space-around;
  }
  .label-wrapper {
    flex-basis: unset;
  }
}
</style>
